// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Rel } from "./Rel";
import { RelFromJSON, RelFromJSONTyped, RelToJSON, RelToJSONTyped } from "./Rel";

/**
 *
 * @export
 * @interface Link
 */
export interface Link {
  /**
   *
   */
  href: string;
  /**
   *
   */
  rel: Rel;
}

/**
 * Check if a given object implements the Link interface.
 */
export function instanceOfLink(value: object): value is Link {
  if (!("href" in value) || value["href"] === undefined) return false;
  if (!("rel" in value) || value["rel"] === undefined) return false;
  return true;
}

export function LinkFromJSON(json: any): Link {
  return LinkFromJSONTyped(json, false);
}

export function LinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): Link {
  if (json == null) {
    return json;
  }
  return {
    href: json["href"],
    rel: RelFromJSON(json["rel"]),
  };
}

export function LinkToJSON(json: any): Link {
  return LinkToJSONTyped(json, false);
}

export function LinkToJSONTyped(value?: Link | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    href: value["href"],
    rel: RelToJSON(value["rel"]),
  };
}
